import {
  PollNewChannel,
  type PollNewChannelProps,
} from '@/true-fsd/features/AwaitNewChannel/PollNewChannel';
import {
  accountPath,
  workspacePath,
  useChannelRequestContext,
} from '@/true-fsd/data/advertiser-account';
import { FigmaWhiteLayout } from '@/true-fsd/shared/ui/FigmaLayout';
import { useCallback } from 'react';

// import classes from './ChannelRequest.module.scss';

export type ChannelRequestPageProps = {
  // className?: string;
};
export const ChannelRequestPage = ({}: ChannelRequestPageProps) => {
  const { activeAccount, activeChannelRequest } = useChannelRequestContext();

  const onCancel: PollNewChannelProps['onCancel'] = useCallback(
    (navigate) => {
      void navigate(accountPath(activeAccount));
    },
    [activeAccount],
  );

  const onContinue = onCancel;

  const onChannel: NonNullable<PollNewChannelProps['onChannel']> = useCallback(
    (navigate, ws) => {
      void navigate(workspacePath(ws));
    },
    [],
  );

  return (
    <PollNewChannel
      RenderLayout={FigmaWhiteLayout}
      onCancel={onCancel}
      channelRequest={activeChannelRequest}
      onChannel={onChannel}
      onContinue={onContinue}
    />
  );
};
